// extracted by mini-css-extract-plugin
export default {"root":"style_root__4fIJ-","questionContent":"style_questionContent__rafjg","buttonAreaWrapper":"style_buttonAreaWrapper__kTQI5","inputRoot":"style_inputRoot__sIy4U"};